
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyCard as SkyCardElement } from '@sky.ui/core/sky-card';
 
 
 
 

 
 export const SkyCard = createComponent({
   displayName: 'SkyCard',
   react: React,
   tagName: 'sky-card',
   elementClass: SkyCardElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-card';
